export const getUserTimezone = () => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return 'default';
    }
  };
  
  export const getUserCountry = () => {
    const userTimeZone = getUserTimezone();
    switch (userTimeZone) {
      case 'America/Argentina/Buenos_Aires':
      case 'America/Argentina/Catamarca':
      case 'America/Argentina/ComodRivadavia':
      case 'America/Argentina/Cordoba':
      case 'America/Argentina/Jujuy':
      case 'America/Argentina/La_Rioja':
      case 'America/Argentina/Mendoza':
      case 'America/Argentina/Rio_Gallegos':
      case 'America/Argentina/Salta':
      case 'America/Argentina/San_Juan':
      case 'America/Argentina/San_Luis':
      case 'America/Argentina/Tucuman':
      case 'America/Argentina/Ushuaia':
      case 'America/Buenos_Aires':
      case 'America/Catamarca':
      case 'America/Cordoba':
      case 'America/Jujuy':
      case 'America/Mendoza':
      case 'America/Rosario':
        // Argentina
        return 'Argentina';
      case 'America/Bahia_Banderas':
      case 'America/Cancun':
      case 'America/Chihuahua':
      case 'America/Ciudad_Juarez':
      case 'America/Ensenada':
      case 'America/Hermosillo':
      case 'America/Matamoros':
      case 'America/Mazatlan':
      case 'America/Merida':
      case 'America/Mexico_City':
      case 'America/Monterrey':
      case 'America/Ojinaga':
      case 'America/Santa_Isabel':
      case 'America/Tijuana':
      case 'Mexico/BajaNorte':
      case 'Mexico/BajaSur':
      case 'Mexico/General':
        // México
        return 'Mexico';
      case 'Africa/Ceuta':
      case 'Atlantic/Canary':
      case 'Europe/Madrid':
        // España
        return 'Espana';
      case 'America/Lima':
        // Peru
        return 'Peru';
      case 'America/Bogota':
        // Colombia
        return 'Colombia';
      default:
        // East US
        return 'East Us';
    }
  };
  